import DatosTransferenciaComponente from "@/erp/inventario/componente/datos-transferencia-componente";
import { IDataTransferenciaInventario } from "@/erp/inventario/componente/datos_transferencia_componente.interface";
import ModalUbicacionProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalUbProductoSelectComponente";
import {
  EstadoTransitoInventarioENUM,
  ROUTER_PATHS,
  formatDate,
  formatDateWithTimeAMPM,
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg4,
  newTransferenciaSchema,
  newTrasladoInventarioSchema,
  texto,
  useLoaders,
  useUploadFile,
} from "@/shared";
import {
  useFetchGetNotificacionInventario,
  useFetchPostNotificacionInventario,
} from "@/shared/actions";
import { useFetchCreateTransferenciaInventario } from "@/shared/actions/erp";
import {
  useFetchPostTransitoInventario,
  useFetchPutTransitoInventario,
} from "@/shared/actions/erp/transito_inventaro.actions";
import {
  LoaderComponent,
  SampleCheckbox,
  SingleTableBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import ModalCorreoExcedente from "@/shared/components/ui/CargarSeries/ModalCorreoExcedente";
import ModalInventariableProductoFactor from "@/shared/components/ui/CargarSeries/ModalInventariableProductoFactor";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableColumnsInventarioSerie } from "@/shared/hooks/useTableColumnsInventarioSerie";
import {
  AlertSeverityEnum,
  ISolicitudTrasladoForm,
  MaterialTransferido,
} from "@/shared/interfaces";
import { ITransitoInventario } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { useAuthStore } from "@/store/auth";
import { useBodegaStore } from "@/store/erp";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { ForwardToInbox } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Button, Grid, Paper } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
const CANTIDAD_DEFAULT = "1";

const defaultForm = {
  es_transito: false,
  bodega_origen_externa: true,
  bodega_destino_externa: true,
  solicitado_por: "",
  estado_transitoinventario: "EN ESPERA",
  fecha_solicitud_transferencia: formatDateWithTimeAMPM(new Date()),
};

type IValidacionError = { mensaje: string; severity: AlertSeverityEnum };

interface SaveTrasladoInventarioProps {
  title: string;
  dataTransitoInventario?: ITransitoInventario;
  modulo?: "INVENTARIO" | "NOTIFICACION";
  notificacion_id?: string | null;
  onSuccess?: () => Promise<void>; //nuevo
  defaultValues?: Partial<ISolicitudTrasladoForm>;
  esTransferenciaPedido?: boolean;
  codigoSolicitud?: string;
}

export default function SaveTrasladoInventario({
  title,
  dataTransitoInventario,
  modulo = "INVENTARIO",
  notificacion_id,
  onSuccess,
  defaultValues,
  esTransferenciaPedido = false,
  codigoSolicitud,
}: SaveTrasladoInventarioProps) {
  const navigate = useNavigate();

  ///// Stores
  const setAlert = useUiStore((s) => s.setAlert);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const username = useAuthStore((s) => s.user?.username);
  const { ubicacionTransito, bodegaTransito } = useBodegaStore();
  const { columnsIngresoInventario } = useTableColumnsInventarioSerie();
  ///
  const columnasTraladoPedido = useMemo(() => {
    if (!esTransferenciaPedido) return columnsIngresoInventario;
    return columnsIngresoInventario.map((col: any) =>
      col.accessorKey === "cantidad" || col.id === "cantidad"
        ? {
            ...col,
            Cell: ({ row }: any) => <span>{row.original?.cantidad}</span>,
          }
        : col,
    );
  }, [columnsIngresoInventario, esTransferenciaPedido]);
  ///
  const { handleUploadFile } = useUploadFile();
  const [notificacionId, setNotificacionId] = useState<string | null>(
    notificacion_id ?? null,
  );
  const [disabledForm, setDisabledForm] = useState(false);
  const [esFlujoNotificacion] = useState<boolean>(false);

  const {
    handleAgregarUrlSerie,
    paginatedData,
    productos,
    setPagination,
    pagination,
    handleAgregarProducto,
    clearSelectedItems,
    handleCopiarLista,
  } = useCargarSeriesProductos((s) => ({
    handleAgregarUrlSerie: s.handleAgregarUrlSerie,
    paginatedData: s.paginatedData,
    productos: s.productos,
    setPagination: s.setPagination,
    pagination: s.pagination,
    handleAgregarProducto: s.handleAgregarProducto,
    clearSelectedItems: s.clearSelectedItems,
    handleCopiarLista: s.handleCopiarLista,
  }));

  ///// Form
  const form = useForm<ISolicitudTrasladoForm, any, ISolicitudTrasladoForm>({
    resolver: yupResolver(newTransferenciaSchema as any),
    defaultValues: defaultForm,
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  const ubicacionDestinoWatch = form.watch("ubicacion_destino");
  const ubicacionOrigenWatch = form.watch("ubicacion_origen");

  ///// React Query
  const {
    mutateAsync: mutateAsyncTransferenciaProducto,
    isPending: isPendingTraslado,
  } = useFetchCreateTransferenciaInventario();
  const { mutateAsync: mutateAsyncPostTransito } =
    useFetchPostTransitoInventario({});
  const { mutateAsync: mutateAsyncPutTransito } = useFetchPutTransitoInventario(
    {},
  );
  const {
    mutateAsync: mutateAsyncPostNotificacion,
    isPending: isPendingNotificacion,
  } = useFetchPostNotificacionInventario({});
  const {
    data: dataNoticacionInventario,
    isPending: isPendingNotificacionInventario,
  } = useFetchGetNotificacionInventario({
    params: {
      ubicacion_destino: ubicacionDestinoWatch || undefined,
      ubicacion_origen: ubicacionOrigenWatch || undefined,
      page_size: 1,
      page: 1,
    },
    enabled: !!ubicacionDestinoWatch,
  });
  ///

  ///// Effects
  useEffect(() => {
    if (dataTransitoInventario) {
      reset({
        ...(dataTransitoInventario as any),
        bodega_origen_externa:
          dataTransitoInventario.bodega_origen_data?.es_externa,
        bodega_destino_externa:
          dataTransitoInventario.bodega_destino_data?.es_externa,
        es_transito: false,
      });
      handleCopiarLista(dataTransitoInventario.productos ?? []);
    } else if (defaultValues) {
      reset({ ...defaultForm, ...defaultValues });
    }
  }, [dataTransitoInventario, defaultValues, reset, handleCopiarLista]);

  useEffect(() => {
    return () => clearSelectedItems();
  }, [clearSelectedItems]);

  ///// Helpers de productos
  function construirProductoTransferencia(producto: any): MaterialTransferido {
    return {
      id: producto.id_producto,
      codigo: producto.codigo,
      cantidad: CANTIDAD_DEFAULT,
      producto_data: {
        codigo: producto.codigo,
        categoria_producto: producto.categoria_producto,
        stock_actual: producto.stock_actual,
        descripcion: producto.descripcion,
        modelo_producto: producto.modelo_producto,
        marca_producto: producto.marca_producto,
        unidad_medida: producto.unidad_medida,
        presentacion: producto.presentacion,
      },
      metros_actuales: producto.metros_actuales,
      contiene_serie: producto.contiene_serie,
      series: [],
      usa_metros: producto.usa_metros,
      ubicacion_origen: form.getValues().ubicacion_origen!,
      ubicacion_destino: form.getValues().ubicacion_destino!,
    };
  }

  function handleAgregarProductoDesdeModal(producto: any) {
    if (producto.stock && +producto.stock! <= 0) {
      return setAlert(
        true,
        `Producto con el código ${producto.codigo} no tiene stock disponible.`,
        AlertSeverityEnum.warning,
      );
    }

    const nuevoProducto = construirProductoTransferencia(producto);
    handleAgregarProducto(nuevoProducto);
  }

  ///// Validación
  function validarProductosAntesEnvio(): IValidacionError | null {
    if (productos.length === 0) {
      return {
        mensaje: "Agregar inventariables",
        severity: AlertSeverityEnum.info,
      };
    }

    if (paginatedData.some((e) => e.producto_data?.stock_actual == 0)) {
      return {
        mensaje: "Algunos productos tienen stock en 0.",
        severity: AlertSeverityEnum.info,
      };
    }

    const productoConCantidadCero = productos.find((p) => p.cantidad == "0");
    if (productoConCantidadCero) {
      return {
        mensaje: `El inventariable ${productoConCantidadCero.codigo} tiene una cantidad de cero.`,
        severity: AlertSeverityEnum.info,
      };
    }

    const productoConErrorSeries = productos.find(
      ({ contiene_serie, series, cantidad, url_archivo }) =>
        contiene_serie &&
        url_archivo == null &&
        (series?.length == 0 || series?.length! != cantidad),
    );

    if (productoConErrorSeries) {
      const { codigo } = productoConErrorSeries.producto_data ?? {};
      const mensaje =
        productoConErrorSeries.series?.length == 0
          ? `El producto con el código ${codigo} tiene series pendientes por cargar.`
          : `El producto con el código ${codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`;

      return { mensaje, severity: AlertSeverityEnum.error };
    }

    return null;
  }

  ///// Confirmación y envío
  async function procesarEnvioTransferencia(
    formData: ISolicitudTrasladoForm,
    correoDiferencia?: any,
  ) {
    const newProductoData = await handleAgregarUrlSerie(handleUploadFile);

    if (!newProductoData) {
      return setAlert(
        true,
        "Error al procesar los productos",
        AlertSeverityEnum.error,
      );
    }

    delete formData.codigo;
    delete formData.numero_referencia;

    const traslado: ISolicitudTrasladoForm = {
      ...formData,
      id_notificacion_inventario: notificacionId,
      productos: newProductoData,
      user: username!,
      observaciones: { observaciones_1: form.getValues().observacion_1 },
      traslado_inicial: null,
      fecha: formatDate(new Date()),
    };
    if (correoDiferencia) traslado.correo_diferencia = correoDiferencia;
    /// Cuando el modulo es por notificacion de inventario debe crear una transferencia
    if (dataTransitoInventario && modulo === "INVENTARIO") {
      await handleEditTransferenciaInventario(formData, traslado);
    } else {
      await handleCrearTransferenciaInventario(formData, traslado);
    }

    clearSelectedItems();
    navigate(ROUTER_PATHS.inventario.trasladoInventario);
  }
  const [openCorreoConsolidado, setOpenCorreoConsolidado] = useState(false);
  const [diffs, setDiffs] = useState<any[]>([]);
  const [pendingFormData, setPendingFormData] =
    useState<ISolicitudTrasladoForm | null>(null);
  const detectarDiferencias = () => {
    return (productos ?? [])
      .filter(
        (p: any) =>
          p?.producto_data?.usa_metros === true &&
          Number(p?.cantidad_metros ?? 0) > 0,
      )
      .map((p: any) => {
        const solicitado = Number(p.cantidad_metros ?? 0);
        const enviado = (p.producto_factor ?? []).reduce(
          (a: number, f: any) => a + Number(f.cantidad_metros ?? 0),
          0,
        );
        const diff = Number((enviado - solicitado).toFixed(2));
        return {
          codigo: p.codigo,
          descripcion: p.producto_data?.descripcion,
          solicitado,
          enviado,
          diferencia: Math.abs(diff),
          tipo: diff > 0 ? "EXCEDENTE" : "FALTANTE",
          diff,
        };
      })
      .filter((d: any) => Math.abs(d.diff) > 0.01);
  };

  const onSubmit = (formData: ISolicitudTrasladoForm) => {
    formData.fecha_actual_fronted = dayjs().toISOString();

    const error = validarProductosAntesEnvio();
    if (error) {
      return setAlert(true, error.mensaje, error.severity);
    }

    const diffsDetectadas = esTransferenciaPedido ? detectarDiferencias() : [];
    if (diffsDetectadas.length > 0) {
      setDiffs(diffsDetectadas);
      setPendingFormData(formData);
      setOpenCorreoConsolidado(true);
      return;
    }

    setConfirmDialogIsOpen(true);
    setConfirmDialog({
      cancelTextBtn: "Salir",
      isOpen: true,
      title: "¡Confirmar!",
      subtitle:
        "Una vez que confirmes la transferencia de inventario, el cambio no se podrá deshacer. ¿Estás seguro de que deseas continuar?",
      onClose() {
        setConfirmDialogIsOpen(false);
      },
      async onConfirm() {
        setConfirmDialogIsOpen(false);
        try {
          await procesarEnvioTransferencia(formData);
        } catch (err) {
          console.error("Error al procesar la transferencia:", err);
        }
      },
    });
  };

  const onSubmitError = () => {
    setAlert(true, texto.campos_obligatorios, AlertSeverityEnum.error);
  };

  ///// Handlers de transferencia
  async function handleEditTransferenciaInventario(
    formData: ISolicitudTrasladoForm,
    traslado: any,
  ) {
    const validacion = await handleValidacionEsTransito(
      formData.es_transito!,
      traslado,
    );

    await mutateAsyncPutTransito({
      id: dataTransitoInventario?.id_transito_inventario!,
      data: {
        ...validacion,
        estado_transito: formData.es_transito
          ? EstadoTransitoInventarioENUM.EN_TRANSITO
          : EstadoTransitoInventarioENUM.EN_ESPERA,
      },
    });
  }

  async function handleCrearTransferenciaInventario(
    formData: ISolicitudTrasladoForm,
    traslado: any,
  ) {
    const esBodegaGeneral =
      !formData.bodega_destino_externa && !formData.bodega_origen_externa;

    if (!esBodegaGeneral) {
      await mutateAsyncTransferenciaProducto(traslado);
      return;
    }

    const validacion = await handleValidacionEsTransito(
      formData.es_transito!,
      traslado,
    );

    const resp = await mutateAsyncPostTransito({
      ...validacion,
      estado_transito: formData.es_transito
        ? EstadoTransitoInventarioENUM.EN_TRANSITO
        : EstadoTransitoInventarioENUM.EN_ESPERA,
    });

    if (resp.code == 200) {
      await mutateAsyncPutTransito({
        id: resp.data.id_transito_inventario,
        data: { productos: resp.data.productos },
      });
    }
  }

  const handleValidacionEsTransito = async (
    es_transito: boolean,
    traslado: any,
  ): Promise<any> => {
    if (!es_transito) return traslado;

    const resp = await mutateAsyncTransferenciaProducto({
      ...traslado,
      bodega_destino: bodegaTransito?.codigo,
      ubicacion_destino: ubicacionTransito?.codigo,
    });

    const productosResp: MaterialTransferido[] = resp.data.productos;

    traslado.productos = productosResp.map(
      ({ series_origen, series_destino, ...element }) => ({
        ...element,
        cantidad_esperada: element.cantidad,
        cantidad_acumulada: "0",
        cantidad: "0",
      }),
    );
    traslado.bodega_transito = bodegaTransito?.codigo;
    traslado.ubicacion_transito = ubicacionTransito?.codigo;
    traslado.traslado_inicial = resp.data.codigo;

    return traslado;
  };

  const handleSendNotificacion = async () => {
    const resp = await mutateAsyncPostNotificacion({
      ...form.getValues(),
      observaciones: { observaciones_1: form.getValues().observacion_1 },
    } as any);

    if (resp.code === 200) {
      reset(defaultForm);
    }
  };

  useLoaders(isPendingNotificacion);

  const mostrarTransitoCheckbox =
    !form.getValues().bodega_destino_externa &&
    !form.getValues().bodega_origen_externa;

  const hayProductosStockCero = paginatedData.some(
    (e) => e.producto_data?.stock_actual == 0,
  );

  const { mostrarBotonNotificacion, mostrarBotonAgregar } = useMemo(() => {
    console.log("dataTransitoInventarioQuery", dataNoticacionInventario);

    let notificacion =
      !form.getValues("bodega_origen_externa") &&
      !!form.getValues("bodega_destino_externa") &&
      form.getValues("estado_transitoinventario") === "EN ESPERA";

    let agregar = !!form.getValues("ubicacion_destino");

    const primerItem = dataNoticacionInventario?.data?.data?.[0];

    if (primerItem?.estado_notificacion_inventario === "APROBADO") {
      agregar = true;
      notificacion = false;
      setNotificacionId(primerItem.id_notificacion_inventario);
      setDisabledForm(true);
      reset({
        ...form.getValues(),
        motivo: primerItem.motivo,
        unidad_transporte: primerItem.unidad_transporte,
        solicitado_por: primerItem.solicitado_por,
        observacion_1: primerItem.observaciones?.observaciones_1 || "",
      });
    } else {
      setDisabledForm(false);
      setNotificacionId(null);
      reset({
        ...form.getValues(),
        motivo: undefined,
        unidad_transporte: undefined,
        solicitado_por: undefined,
        observacion_1: undefined,
      });
    }

    return {
      mostrarBotonNotificacion: notificacion,
      mostrarBotonAgregar: agregar,
    };
  }, [dataNoticacionInventario, ubicacionDestinoWatch]);

  ///// Render
  return (
    <>
      <SingleTableBoxScene
        py={0}
        px={0}
        title={title}
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.trasladoInventario}
        enableCreateOrEditBtn={mostrarBotonAgregar}
        textCreateOrEditBtn="Transferir"
        iconCreateOrEdit={<LocalShippingIcon />}
        fnCreateOrEdit={handleSubmit(onSubmit, onSubmitError)}
      >
        <Grid item {...gridSizeMdLg12} sx={{ padding: "40px 20px" }}>
          <Grid container spacing={2}>
            <DatosTransferenciaComponente
              control={control}
              errors={errors}
              form={form}
              reset={reset}
              dataTransferenciaInventario={
                dataTransitoInventario as IDataTransferenciaInventario
              }
              onChangeDeleteItem={() => clearSelectedItems()}
              disabledForm={disabledForm}
            />

            {hayProductosStockCero && (
              <CustomAlertCard
                alertColor="info"
                alertTitle="Algunos productos tienen stock en 0."
                alertMessage="Te recomendamos buscar en otra ubicación o registrar un nuevo ingreso de inventario."
              />
            )}

            {mostrarTransitoCheckbox && (
              <Grid item xs={12}>
                <SampleCheckbox
                  label={texto.transito_inventario}
                  name="es_transito"
                  control={form.control}
                  defaultValue={!!form.getValues().es_transito}
                  size={gridSizeMdLg12}
                  onChangeValue={(value) => {
                    reset({ ...form.getValues(), es_transito: value });
                  }}
                />
              </Grid>
            )}

            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid
                  container
                  spacing={1}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabTextLabel
                      text="Items Seleccionados"
                      mt={0}
                      pb={0}
                      pl={0}
                      pt={0}
                    />
                  </Grid>

                  {!esTransferenciaPedido &&
                    (esFlujoNotificacion ? (
                      <>
                        {mostrarBotonAgregar && (
                          <Grid item sx={{ display: "inline-flex", gap: 1 }}>
                            {mostrarBotonNotificacion && (
                              <Button
                                startIcon={<ForwardToInbox />}
                                variant="outlined"
                                onClick={handleSubmit(
                                  handleSendNotificacion,
                                  onSubmitError,
                                )}
                              >
                                Enviar Notificación
                              </Button>
                            )}

                            {!mostrarBotonNotificacion && (
                              <ModalUbicacionProductoSelectComponente
                                ubicacion={form.getValues().ubicacion_origen!}
                                control={control}
                                label="Agregar Items"
                                onChange={handleAgregarProductoDesdeModal}
                              />
                            )}
                          </Grid>
                        )}
                      </>
                    ) : (
                      <ModalUbicacionProductoSelectComponente
                        ubicacion={form.getValues().ubicacion_origen!}
                        control={control}
                        label="Agregar Items"
                        onChange={handleAgregarProductoDesdeModal}
                      />
                    ))}

                  <div className="linea"></div>

                  <Grid item xs={12}>
                    <SampleTablePagination
                      columns={columnsIngresoInventario}
                      // columns={columnasTraladoPedido}
                      data={paginatedData}
                      rowCount={productos.length}
                      setPagination={setPagination}
                      pagination={pagination}
                      rowNumber={true}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </SingleTableBoxScene>

      <ModalInventariableProductoFactor
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg4}
      />
      {esTransferenciaPedido && (
        <ModalCorreoExcedente
          open={openCorreoConsolidado}
          onClose={() => setOpenCorreoConsolidado(false)}
          codigoSolicitud={codigoSolicitud}
          diffs={diffs}
          onEnviado={async (correoData) => {
            setOpenCorreoConsolidado(false);
            if (pendingFormData) {
              try {
                await procesarEnvioTransferencia(pendingFormData, correoData);
              } catch (err) {
                console.error(err);
              }
            }
          }}
        />
      )}
    </>
  );
}
